import { render, staticRenderFns } from "./xwglEdit.vue?vue&type=template&id=421322fd&scoped=true&"
import script from "./xwglEdit.vue?vue&type=script&lang=js&"
export * from "./xwglEdit.vue?vue&type=script&lang=js&"
import style0 from "./xwglEdit.vue?vue&type=style&index=0&id=421322fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421322fd",
  null
  
)

export default component.exports